/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  IconButton,
  TablePagination,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { formatUtcForDisplay } from '../utils/dateTime';

function ConsumoAguaList({ refresh, onEdit, onConsumoAguaDeleted }) {
  const { user } = useAuth();
  const [consumos, setConsumos] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const fetchConsumos = () => {
    api.get(`/consumo-agua?page=${page}&limit=${rowsPerPage}`)
      .then((response) => {
        setConsumos(response.data.data);
        setTotalCount(response.data.totalCount);
      })
      .catch((error) => {
        console.error('Erro ao buscar consumo de agua:', error);
      });
  };

  useEffect(() => {
    fetchConsumos();
  }, [refresh, page, rowsPerPage]);

  const handleDelete = async (id) => {
    if (!window.confirm('Tem certeza que deseja deletar este registro de consumo?')) return;
    try {
      await api.delete(`/consumo-agua/${id}`);
      onConsumoAguaDeleted();
    } catch (error) {
      console.error('Erro ao deletar consumo de agua:', error);
    }
  };

  return (
    <Paper>
      <TableContainer>
        <Table sx={{ minWidth: 650 }} aria-label="consumo agua table">
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              {user?.tipo_usuario === 'admin' && <TableCell>Empresa ID</TableCell>}
              <TableCell>Funcionário</TableCell>
              <TableCell align="right">Leitura (m³)</TableCell>
              <TableCell align="right">Consumo (m³)</TableCell>
              <TableCell>Data e Hora</TableCell>
              <TableCell>Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {consumos.map((consumo) => (
              <TableRow key={consumo.id} hover>
                <TableCell>{consumo.id}</TableCell>
                {user?.tipo_usuario === 'admin' && <TableCell>{consumo.empresa_id}</TableCell>}
                <TableCell>{consumo.pessoa_nome || consumo.pessoa_id}</TableCell>
                <TableCell align="right">{Number(consumo.leitura).toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })}</TableCell>
                <TableCell align="right">{Number(consumo.consumo).toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })}</TableCell>
                <TableCell>{formatUtcForDisplay(consumo.data_hora_leitura, user)}</TableCell>
                <TableCell>
                  <IconButton aria-label="edit" onClick={() => onEdit(consumo)}>
                    <EditIcon />
                  </IconButton>
                  <IconButton aria-label="delete" onClick={() => handleDelete(consumo.id)}>
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={totalCount}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(event, newPage) => setPage(newPage)}
        onRowsPerPageChange={(event) => {
          setRowsPerPage(parseInt(event.target.value, 10));
          setPage(0);
        }}
        labelRowsPerPage="Linhas por página:"
        labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
      />
    </Paper>
  );
}

export default ConsumoAguaList;
